/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPETHNICITY = {
    Asian: 'A',
    Black: 'B',
    Coloured: 'C',
    White: 'W',
    Unknown: 'U'
} as const;
export type IAPETHNICITY = typeof IAPETHNICITY[keyof typeof IAPETHNICITY];


export function IAPETHNICITYFromJSON(json: any): IAPETHNICITY {
    return IAPETHNICITYFromJSONTyped(json, false);
}

export function IAPETHNICITYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPETHNICITY {
    return json as IAPETHNICITY;
}

export function IAPETHNICITYToJSON(value?: IAPETHNICITY | null): any {
    return value as any;
}

